{
  "$schema": "./strings.schema.json",
  "$table": "strings-a30.json",
  "$dialect": "A-30 dialect (downstairs)",
  "$generatedBy": "decoys/generate.mjs",
  "$note": "generated translation dump. the dump wins; hand edits are swept.",
  "entries": {
    "comments.title": "Comments",
    "comments.empty": "Nothing here. The desk is grateful.",
    "comments.post": "Post comment",
    "comments.placeholder": "Say something the desk can defend.",
    "comments.pending": "Held for moderation. Both of them.",
    "comments.disabled": "Comments are closed on this story. It is happier this way.",
    "comments.moderated": "A moderator read this. The moderator is fine.",
    "comment.reply": "Reply",
    "comment.report": "Report to universe of origin",
    "comment.like": "Duly noted",
    "comments.policy": "House rules: be kind, be legible, be from somewhere.",
    "reader.welcome": "You are among readers.",
    "reader.farewell": "Sent. The desk saw it leave.",
    "error.generic": "The page declined. No feelings involved.",
    "nav.front": "Front page",
    "nav.editions": "Editions",
    "nav.archive": "Archive",
    "nav.signup": "Sign up",
    "footer.line": "Sideways Argus — A-30 edition",
    "footer.rights": "All rights reserved, in this universe only.",
    "ui.cta.v1": "Keep reading",
    "ui.cta.v2": "Look inside",
    "ui.cta.v3": "Unfold",
    "ui.cta.v4": "Open",
    "ui.cta.v5": "See more",
    "ui.cta.v6": "Look inside",
    "ui.cta.v7": "Keep reading",
    "ui.cta.v8": "Open",
    "ui.cta.v9": "Go on",
    "ui.cta.v10": "Continue",
    "ui.cta.v11": "Keep reading",
    "ui.cta.v12": "Continue",
    "ui.cta.v13": "Unfold",
    "ui.cta.v14": "Continue",
    "ui.cta.v15": "See more",
    "ui.cta.v16": "Look inside",
    "ui.cta.v17": "Open edition",
    "ui.cta.v18": "View page",
    "ui.cta.v19": "Go on",
    "ui.cta.v20": "Open",
    "ui.cta.v21": "Unfold",
    "ui.cta.v22": "Open",
    "ui.cta.v23": "Unfold",
    "ui.cta.v24": "Open edition",
    "ui.cta.v25": "See more",
    "ui.cta.v26": "Look inside",
    "ui.cta.v27": "Open edition",
    "ui.cta.v28": "View page",
    "ui.cta.v29": "Unfold",
    "ui.cta.v30": "Read",
    "ui.cta.v31": "Unfold",
    "ui.cta.v32": "Open",
    "ui.cta.v33": "Unfold",
    "ui.cta.v34": "Open edition",
    "ui.cta.v35": "Go on",
    "ui.cta.v36": "Unfold",
    "ui.cta.v37": "Open edition",
    "ui.cta.v38": "Read",
    "ui.cta.v39": "Go on",
    "ui.cta.v40": "Read",
    "ui.cta.v41": "Keep reading",
    "ui.cta.v42": "Open",
    "ui.cta.v43": "Keep reading",
    "ui.cta.v44": "Continue",
    "ui.cta.v45": "Go on",
    "ui.cta.v46": "Look inside",
    "ui.cta.v47": "Open edition",
    "ui.cta.v48": "View page",
    "ui.cta.v49": "Open",
    "ui.cta.v50": "Open",
    "ui.cta.v51": "View page",
    "ui.cta.v52": "See more",
    "ui.cta.v53": "Unfold",
    "ui.cta.v54": "Continue",
    "ui.cta.v55": "See more",
    "ui.cta.v56": "View page",
    "ui.cta.v57": "Open edition",
    "ui.cta.v58": "View page",
    "ui.cta.v59": "Keep reading",
    "ui.cta.v60": "Read",
    "ui.cta.v61": "Keep reading",
    "ui.cta.v62": "Open",
    "ui.cta.v63": "Unfold",
    "ui.cta.v64": "Continue",
    "ui.cta.v65": "Open",
    "ui.cta.v66": "Unfold",
    "ui.cta.v67": "Continue",
    "ui.cta.v68": "Keep reading",
    "ui.cta.v69": "Read",
    "ui.cta.v70": "Read",
    "ui.cta.v71": "Keep reading",
    "ui.cta.v72": "Open",
    "ui.cta.v73": "Open",
    "ui.cta.v74": "Continue",
    "ui.cta.v75": "Keep reading",
    "ui.cta.v76": "Continue",
    "ui.cta.v77": "Open",
    "ui.cta.v78": "Open",
    "ui.cta.v79": "Go on",
    "ui.cta.v80": "Go on",
    "ui.cta.v81": "Keep reading",
    "ui.cta.v82": "Open",
    "ui.cta.v83": "Unfold",
    "ui.cta.v84": "See more",
    "ui.cta.v85": "See more",
    "ui.cta.v86": "View page",
    "ui.cta.v87": "Look inside",
    "ui.cta.v88": "Continue",
    "ui.cta.v89": "Read",
    "ui.cta.v90": "Read",
    "ui.cta.v91": "Look inside",
    "ui.cta.v92": "Read",
    "ui.cta.v93": "Unfold",
    "ui.cta.v94": "See more",
    "ui.cta.v95": "Continue",
    "ui.cta.v96": "Continue",
    "ui.cta.v97": "Open edition",
    "ui.cta.v98": "Go on",
    "ui.cta.v99": "Go on",
    "ui.cta.v100": "Read",
    "ui.cta.v101": "View page",
    "ui.cta.v102": "Open",
    "ui.cta.v103": "Unfold",
    "ui.cta.v104": "Continue",
    "ui.cta.v105": "Read",
    "ui.cta.v106": "Look inside",
    "ui.cta.v107": "Open edition",
    "ui.cta.v108": "View page",
    "ui.cta.v109": "Go on",
    "ui.cta.v110": "Unfold",
    "ui.cta.v111": "Keep reading",
    "ui.cta.v112": "Open",
    "ui.cta.v113": "See more",
    "ui.cta.v114": "Open",
    "ui.cta.v115": "Open",
    "ui.cta.v116": "Unfold",
    "ui.cta.v117": "Go on",
    "ui.cta.v118": "Keep reading",
    "ui.cta.v119": "Go on",
    "ui.cta.v120": "Read",
    "ui.cta.v121": "Keep reading",
    "ui.cta.v122": "Unfold",
    "ui.cta.v123": "Unfold",
    "ui.cta.v124": "Read",
    "ui.cta.v125": "Read",
    "ui.cta.v126": "Look inside",
    "ui.cta.v127": "Continue",
    "ui.cta.v128": "Unfold",
    "ui.cta.v129": "Go on",
    "ui.cta.v130": "Read",
    "ui.cta.v131": "Look inside",
    "ui.cta.v132": "Continue",
    "ui.cta.v133": "View page",
    "ui.cta.v134": "Continue",
    "ui.cta.v135": "Go on",
    "ui.toast.v1": "Printed to the archive of intentions.",
    "ui.toast.v2": "Sent. The desk saw it leave.",
    "ui.toast.v3": "Printed to the archive of intentions.",
    "ui.toast.v4": "Delivered to your universe of record.",
    "ui.toast.v5": "Set in ink, provisionally.",
    "ui.toast.v6": "Synchronized across the corridor.",
    "ui.toast.v7": "Noted, in the margin.",
    "ui.toast.v8": "Delivered to your universe of record.",
    "ui.toast.v9": "Synchronized across the corridor.",
    "ui.toast.v10": "Printed to the archive of intentions.",
    "ui.toast.v11": "Noted, in the margin.",
    "ui.toast.v12": "Saved. Somewhere.",
    "ui.toast.v13": "Noted, in the margin.",
    "ui.toast.v14": "Filed under patience.",
    "ui.toast.v15": "Printed to the archive of intentions.",
    "ui.toast.v16": "Delivered to your universe of record.",
    "ui.toast.v17": "Synchronized across the corridor.",
    "ui.toast.v18": "Set in ink, provisionally.",
    "ui.toast.v19": "Saved. Somewhere.",
    "ui.toast.v20": "Drafted, with feeling.",
    "ui.toast.v21": "Set in ink, provisionally.",
    "ui.toast.v22": "Set in ink, provisionally.",
    "ui.toast.v23": "Set in ink, provisionally.",
    "ui.toast.v24": "Saved. Somewhere.",
    "ui.toast.v25": "Noted, in the margin.",
    "ui.toast.v26": "Filed under patience.",
    "ui.toast.v27": "Printed to the archive of intentions.",
    "ui.toast.v28": "Delivered to your universe of record.",
    "ui.toast.v29": "Understood. Not acted on. Yet.",
    "ui.toast.v30": "Queued behind two universes.",
    "ui.toast.v31": "Filed under patience.",
    "ui.toast.v32": "Drafted, with feeling.",
    "ui.toast.v33": "Noted, in the margin.",
    "ui.toast.v34": "Set in ink, provisionally.",
    "ui.toast.v35": "Held for editorial review.",
    "ui.toast.v36": "Synchronized across the corridor.",
    "ui.toast.v37": "Noted, in the margin.",
    "ui.toast.v38": "Filed under patience.",
    "ui.toast.v39": "Printed to the archive of intentions.",
    "ui.toast.v40": "Delivered to your universe of record.",
    "ui.toast.v41": "Held for editorial review.",
    "ui.toast.v42": "Saved. Somewhere.",
    "ui.toast.v43": "Sent. The desk saw it leave.",
    "ui.toast.v44": "Saved. Somewhere.",
    "ui.toast.v45": "Synchronized across the corridor.",
    "ui.toast.v46": "Set in ink, provisionally.",
    "ui.toast.v47": "Noted, in the margin.",
    "ui.toast.v48": "Saved. Somewhere.",
    "ui.toast.v49": "Noted, in the margin.",
    "ui.toast.v50": "Filed under patience.",
    "ui.toast.v51": "Sent. The desk saw it leave.",
    "ui.toast.v52": "Saved. Somewhere.",
    "ui.toast.v53": "Held for editorial review.",
    "ui.toast.v54": "Queued behind two universes.",
    "ui.toast.v55": "Sent. The desk saw it leave.",
    "ui.toast.v56": "Set in ink, provisionally.",
    "ui.toast.v57": "Synchronized across the corridor.",
    "ui.toast.v58": "Held for editorial review.",
    "ui.toast.v59": "Understood. Not acted on. Yet.",
    "ui.toast.v60": "Saved. Somewhere.",
    "ui.toast.v61": "Held for editorial review.",
    "ui.toast.v62": "Held for editorial review.",
    "ui.toast.v63": "Printed to the archive of intentions.",
    "ui.toast.v64": "Delivered to your universe of record.",
    "ui.toast.v65": "Held for editorial review.",
    "ui.toast.v66": "Understood. Not acted on. Yet.",
    "ui.toast.v67": "Sent. The desk saw it leave.",
    "ui.toast.v68": "Drafted, with feeling.",
    "ui.toast.v69": "Noted, in the margin.",
    "ui.toast.v70": "Set in ink, provisionally.",
    "ui.toast.v71": "Synchronized across the corridor.",
    "ui.toast.v72": "Synchronized across the corridor.",
    "ui.toast.v73": "Set in ink, provisionally.",
    "ui.toast.v74": "Filed under patience.",
    "ui.toast.v75": "Delivered to your universe of record.",
    "ui.toast.v76": "Filed under patience.",
    "ui.toast.v77": "Held for editorial review.",
    "ui.toast.v78": "Set in ink, provisionally.",
    "ui.toast.v79": "Sent. The desk saw it leave.",
    "ui.toast.v80": "Filed under patience.",
    "ui.toast.v81": "Synchronized across the corridor.",
    "ui.toast.v82": "Set in ink, provisionally.",
    "ui.toast.v83": "Synchronized across the corridor.",
    "ui.toast.v84": "Synchronized across the corridor.",
    "ui.toast.v85": "Noted, in the margin.",
    "ui.toast.v86": "Filed under patience.",
    "ui.toast.v87": "Printed to the archive of intentions.",
    "ui.toast.v88": "Drafted, with feeling.",
    "ui.toast.v89": "Noted, in the margin.",
    "ui.toast.v90": "Drafted, with feeling.",
    "ui.toast.v91": "Queued behind two universes.",
    "ui.toast.v92": "Filed under patience.",
    "ui.toast.v93": "Synchronized across the corridor.",
    "ui.toast.v94": "Set in ink, provisionally.",
    "ui.toast.v95": "Drafted, with feeling.",
    "ui.toast.v96": "Synchronized across the corridor.",
    "ui.toast.v97": "Printed to the archive of intentions.",
    "ui.toast.v98": "Printed to the archive of intentions.",
    "ui.toast.v99": "Printed to the archive of intentions.",
    "ui.toast.v100": "Delivered to your universe of record.",
    "ui.toast.v101": "Held for editorial review.",
    "ui.toast.v102": "Saved. Somewhere.",
    "ui.toast.v103": "Sent. The desk saw it leave.",
    "ui.toast.v104": "Drafted, with feeling.",
    "ui.toast.v105": "Synchronized across the corridor.",
    "ui.toast.v106": "Synchronized across the corridor.",
    "ui.toast.v107": "Noted, in the margin.",
    "ui.toast.v108": "Sent. The desk saw it leave.",
    "ui.toast.v109": "Noted, in the margin.",
    "ui.toast.v110": "Understood. Not acted on. Yet.",
    "ui.toast.v111": "Noted, in the margin.",
    "ui.toast.v112": "Delivered to your universe of record.",
    "ui.toast.v113": "Held for editorial review.",
    "ui.toast.v114": "Saved. Somewhere.",
    "ui.toast.v115": "Printed to the archive of intentions.",
    "ui.toast.v116": "Saved. Somewhere.",
    "ui.toast.v117": "Saved. Somewhere.",
    "ui.toast.v118": "Held for editorial review.",
    "ui.toast.v119": "Saved. Somewhere.",
    "ui.toast.v120": "Queued behind two universes.",
    "ui.toast.v121": "Noted, in the margin.",
    "ui.toast.v122": "Filed under patience.",
    "ui.toast.v123": "Drafted, with feeling.",
    "ui.toast.v124": "Delivered to your universe of record.",
    "ui.toast.v125": "Filed under patience.",
    "ui.toast.v126": "Sent. The desk saw it leave.",
    "ui.toast.v127": "Sent. The desk saw it leave.",
    "ui.toast.v128": "Noted, in the margin.",
    "ui.toast.v129": "Synchronized across the corridor.",
    "ui.toast.v130": "Set in ink, provisionally.",
    "ui.toast.v131": "Sent. The desk saw it leave.",
    "ui.toast.v132": "Synchronized across the corridor.",
    "ui.toast.v133": "Filed under patience.",
    "ui.toast.v134": "Understood. Not acted on. Yet.",
    "ui.toast.v135": "Printed to the archive of intentions.",
    "greeting.formal.v1": "You are among readers.",
    "greeting.formal.v2": "You are among readers.",
    "greeting.formal.v3": "Welcome back, presumably.",
    "greeting.formal.v4": "The desk acknowledges you.",
    "greeting.formal.v5": "The paper remembers you fondly.",
    "greeting.formal.v6": "The paper remembers you fondly.",
    "greeting.formal.v7": "You are receiving this correctly.",
    "greeting.formal.v8": "The paper remembers you fondly.",
    "greeting.formal.v9": "The desk acknowledges you.",
    "greeting.formal.v10": "You are receiving this correctly.",
    "greeting.formal.v11": "You are receiving this correctly.",
    "greeting.formal.v12": "Welcome back, presumably.",
    "greeting.formal.v13": "The paper remembers you fondly.",
    "greeting.formal.v14": "We read you with both eyes open.",
    "greeting.formal.v15": "You are receiving this correctly.",
    "greeting.formal.v16": "We read you with both eyes open.",
    "greeting.formal.v17": "You are among readers.",
    "greeting.formal.v18": "You are among readers.",
    "greeting.formal.v19": "Welcome back, presumably.",
    "greeting.formal.v20": "Your universe of record stands confirmed.",
    "greeting.formal.v21": "The paper remembers you fondly.",
    "greeting.formal.v22": "Good day. It is a news day.",
    "greeting.formal.v23": "You are receiving this correctly.",
    "greeting.formal.v24": "The paper remembers you fondly.",
    "greeting.formal.v25": "We read you with both eyes open.",
    "greeting.formal.v26": "You are among readers.",
    "greeting.formal.v27": "We read you with both eyes open.",
    "greeting.formal.v28": "Your universe of record stands confirmed.",
    "greeting.formal.v29": "The paper remembers you fondly.",
    "greeting.formal.v30": "Good day. It is a news day.",
    "greeting.formal.v31": "The paper remembers you fondly.",
    "greeting.formal.v32": "Your universe of record stands confirmed.",
    "greeting.formal.v33": "The desk acknowledges you.",
    "greeting.formal.v34": "You are among readers.",
    "greeting.formal.v35": "Welcome back, presumably.",
    "greeting.formal.v36": "Good day. It is a news day.",
    "greeting.formal.v37": "We read you with both eyes open.",
    "greeting.formal.v38": "You are among readers.",
    "greeting.formal.v39": "The paper remembers you fondly.",
    "greeting.formal.v40": "We read you with both eyes open.",
    "greeting.formal.v41": "You are among readers.",
    "greeting.formal.v42": "We read you with both eyes open.",
    "greeting.formal.v43": "We read you with both eyes open.",
    "greeting.formal.v44": "Good day. It is a news day.",
    "greeting.formal.v45": "The paper remembers you fondly.",
    "greeting.formal.v46": "Good day. It is a news day.",
    "greeting.formal.v47": "You are receiving this correctly.",
    "greeting.formal.v48": "We read you with both eyes open.",
    "greeting.formal.v49": "Good day. It is a news day.",
    "greeting.formal.v50": "You are receiving this correctly.",
    "greeting.formal.v51": "You are among readers.",
    "greeting.formal.v52": "Your universe of record stands confirmed.",
    "greeting.formal.v53": "Welcome back, presumably.",
    "greeting.formal.v54": "Good day. It is a news day.",
    "greeting.formal.v55": "You are receiving this correctly.",
    "greeting.formal.v56": "Good day. It is a news day.",
    "greeting.formal.v57": "The desk acknowledges you.",
    "greeting.formal.v58": "You are among readers.",
    "greeting.formal.v59": "Welcome back, presumably.",
    "greeting.formal.v60": "Your universe of record stands confirmed.",
    "greeting.formal.v61": "Good day. It is a news day.",
    "greeting.formal.v62": "Your universe of record stands confirmed.",
    "greeting.formal.v63": "Good day. It is a news day.",
    "greeting.formal.v64": "We read you with both eyes open.",
    "greeting.formal.v65": "The paper remembers you fondly.",
    "greeting.formal.v66": "You are among readers.",
    "greeting.formal.v67": "Welcome back, presumably.",
    "greeting.formal.v68": "Your universe of record stands confirmed.",
    "greeting.formal.v69": "The paper remembers you fondly.",
    "greeting.formal.v70": "Good day. It is a news day.",
    "greeting.formal.v71": "You are receiving this correctly.",
    "greeting.formal.v72": "We read you with both eyes open.",
    "greeting.formal.v73": "The desk acknowledges you.",
    "greeting.formal.v74": "The desk acknowledges you.",
    "greeting.formal.v75": "Welcome back, presumably.",
    "greeting.formal.v76": "Your universe of record stands confirmed.",
    "greeting.formal.v77": "The paper remembers you fondly.",
    "greeting.formal.v78": "Good day. It is a news day.",
    "greeting.formal.v79": "You are receiving this correctly.",
    "greeting.formal.v80": "Welcome back, presumably.",
    "greeting.formal.v81": "Good day. It is a news day.",
    "greeting.formal.v82": "Good day. It is a news day.",
    "greeting.formal.v83": "Welcome back, presumably.",
    "greeting.formal.v84": "The desk acknowledges you.",
    "greeting.formal.v85": "The paper remembers you fondly.",
    "greeting.formal.v86": "Good day. It is a news day.",
    "greeting.formal.v87": "The paper remembers you fondly.",
    "greeting.formal.v88": "Welcome back, presumably.",
    "greeting.formal.v89": "The desk acknowledges you.",
    "greeting.formal.v90": "You are among readers.",
    "error.soft.v1": "That failed quietly, as designed.",
    "error.soft.v2": "Something did not happen. The desk is informed.",
    "error.soft.v3": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v4": "The ink smudged. Try again.",
    "error.soft.v5": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v6": "Something did not happen. The desk is informed.",
    "error.soft.v7": "That failed quietly, as designed.",
    "error.soft.v8": "The page declined. No feelings involved.",
    "error.soft.v9": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v10": "The ink smudged. Try again.",
    "error.soft.v11": "This did not work. It did not work politely.",
    "error.soft.v12": "This did not work. It did not work politely.",
    "error.soft.v13": "This did not work. It did not work politely.",
    "error.soft.v14": "The page declined. No feelings involved.",
    "error.soft.v15": "Something did not happen. The desk is informed.",
    "error.soft.v16": "The ink smudged. Try again.",
    "error.soft.v17": "This did not work. It did not work politely.",
    "error.soft.v18": "Something did not happen. The desk is informed.",
    "error.soft.v19": "That failed quietly, as designed.",
    "error.soft.v20": "Something did not happen. The desk is informed.",
    "error.soft.v21": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v22": "That failed quietly, as designed.",
    "error.soft.v23": "This did not work. It did not work politely.",
    "error.soft.v24": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v25": "That failed quietly, as designed.",
    "error.soft.v26": "That failed quietly, as designed.",
    "error.soft.v27": "This did not work. It did not work politely.",
    "error.soft.v28": "The ink smudged. Try again.",
    "error.soft.v29": "This did not work. It did not work politely.",
    "error.soft.v30": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v31": "This did not work. It did not work politely.",
    "error.soft.v32": "This did not work. It did not work politely.",
    "error.soft.v33": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v34": "The ink smudged. Try again.",
    "error.soft.v35": "The ink smudged. Try again.",
    "error.soft.v36": "Something did not happen. The desk is informed.",
    "error.soft.v37": "Something did not happen. The desk is informed.",
    "error.soft.v38": "The page declined. No feelings involved.",
    "error.soft.v39": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v40": "Something did not happen. The desk is informed.",
    "error.soft.v41": "The ink smudged. Try again.",
    "error.soft.v42": "The ink smudged. Try again.",
    "error.soft.v43": "This did not work. It did not work politely.",
    "error.soft.v44": "The page declined. No feelings involved.",
    "error.soft.v45": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v46": "The ink smudged. Try again.",
    "error.soft.v47": "This did not work. It did not work politely.",
    "error.soft.v48": "That failed quietly, as designed.",
    "error.soft.v49": "The ink smudged. Try again.",
    "error.soft.v50": "That failed quietly, as designed.",
    "error.soft.v51": "Something did not happen. The desk is informed.",
    "error.soft.v52": "The ink smudged. Try again.",
    "error.soft.v53": "This did not work. It did not work politely.",
    "error.soft.v54": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v55": "Something did not happen. The desk is informed.",
    "error.soft.v56": "The page declined. No feelings involved.",
    "error.soft.v57": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v58": "Something did not happen. The desk is informed.",
    "error.soft.v59": "This did not work. It did not work politely.",
    "error.soft.v60": "Something did not happen. The desk is informed.",
    "error.soft.v61": "That failed quietly, as designed.",
    "error.soft.v62": "This did not work. It did not work politely.",
    "error.soft.v63": "The page declined. No feelings involved.",
    "error.soft.v64": "The ink smudged. Try again.",
    "error.soft.v65": "This did not work. It did not work politely.",
    "error.soft.v66": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v67": "That failed quietly, as designed.",
    "error.soft.v68": "The page declined. No feelings involved.",
    "error.soft.v69": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v70": "The ink smudged. Try again.",
    "error.soft.v71": "This did not work. It did not work politely.",
    "error.soft.v72": "Something did not happen. The desk is informed.",
    "error.soft.v73": "That failed quietly, as designed.",
    "error.soft.v74": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v75": "The ink smudged. Try again.",
    "error.soft.v76": "The ink smudged. Try again.",
    "error.soft.v77": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v78": "Something did not happen. The desk is informed.",
    "error.soft.v79": "That failed quietly, as designed.",
    "error.soft.v80": "The ink smudged. Try again.",
    "error.soft.v81": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v82": "Something did not happen. The desk is informed.",
    "error.soft.v83": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v84": "Something did not happen. The desk is informed.",
    "error.soft.v85": "Something did not happen. The desk is informed.",
    "error.soft.v86": "Something did not happen. The desk is informed.",
    "error.soft.v87": "Something did not happen. The desk is informed.",
    "error.soft.v88": "Something did not happen. The desk is informed.",
    "error.soft.v89": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v90": "The ink smudged. Try again.",
    "empty.state.v1": "Nothing yet. The ferry may be late.",
    "empty.state.v2": "Blank, but typeset.",
    "empty.state.v3": "Empty, like the print room on Sundays.",
    "empty.state.v4": "Empty, like the print room on Sundays.",
    "empty.state.v5": "Nothing here. The desk is grateful.",
    "empty.state.v6": "Nothing yet. The ferry may be late.",
    "empty.state.v7": "No entries. Consider writing one.",
    "empty.state.v8": "Blank, but typeset.",
    "empty.state.v9": "No entries. Consider writing one.",
    "empty.state.v10": "Nothing here. The desk is grateful.",
    "empty.state.v11": "Nothing here. The desk is grateful.",
    "empty.state.v12": "Blank, but typeset.",
    "empty.state.v13": "No entries. Consider writing one.",
    "empty.state.v14": "Blank, but typeset.",
    "empty.state.v15": "Nothing yet. The ferry may be late.",
    "empty.state.v16": "Empty, like the print room on Sundays.",
    "empty.state.v17": "No entries. Consider writing one.",
    "empty.state.v18": "Blank, but typeset.",
    "empty.state.v19": "Nothing yet. The ferry may be late.",
    "empty.state.v20": "Blank, but typeset.",
    "empty.state.v21": "No entries. Consider writing one.",
    "empty.state.v22": "No entries. Consider writing one.",
    "empty.state.v23": "Blank, but typeset.",
    "empty.state.v24": "Nothing yet. The ferry may be late.",
    "empty.state.v25": "No entries. Consider writing one.",
    "empty.state.v26": "Nothing here. The desk is grateful.",
    "empty.state.v27": "No entries. Consider writing one.",
    "empty.state.v28": "Blank, but typeset.",
    "empty.state.v29": "No entries. Consider writing one.",
    "empty.state.v30": "No entries. Consider writing one.",
    "empty.state.v31": "Empty, like the print room on Sundays.",
    "empty.state.v32": "Empty, like the print room on Sundays.",
    "empty.state.v33": "Empty, like the print room on Sundays.",
    "empty.state.v34": "Nothing here. The desk is grateful.",
    "empty.state.v35": "No entries. Consider writing one.",
    "empty.state.v36": "Empty, like the print room on Sundays.",
    "empty.state.v37": "Nothing yet. The ferry may be late.",
    "empty.state.v38": "Blank, but typeset.",
    "empty.state.v39": "Nothing yet. The ferry may be late.",
    "empty.state.v40": "Nothing here. The desk is grateful.",
    "empty.state.v41": "Empty, like the print room on Sundays.",
    "empty.state.v42": "No entries. Consider writing one.",
    "empty.state.v43": "Nothing here. The desk is grateful.",
    "empty.state.v44": "Blank, but typeset.",
    "empty.state.v45": "Nothing here. The desk is grateful.",
    "empty.state.v46": "Nothing yet. The ferry may be late.",
    "empty.state.v47": "No entries. Consider writing one.",
    "empty.state.v48": "No entries. Consider writing one.",
    "empty.state.v49": "Nothing yet. The ferry may be late.",
    "empty.state.v50": "No entries. Consider writing one.",
    "empty.state.v51": "Nothing yet. The ferry may be late.",
    "empty.state.v52": "No entries. Consider writing one.",
    "empty.state.v53": "Blank, but typeset.",
    "empty.state.v54": "Nothing yet. The ferry may be late.",
    "empty.state.v55": "Nothing here. The desk is grateful.",
    "empty.state.v56": "Empty, like the print room on Sundays.",
    "empty.state.v57": "No entries. Consider writing one.",
    "empty.state.v58": "Blank, but typeset.",
    "empty.state.v59": "Blank, but typeset.",
    "empty.state.v60": "Blank, but typeset.",
    "empty.state.v61": "No entries. Consider writing one.",
    "empty.state.v62": "Blank, but typeset.",
    "empty.state.v63": "No entries. Consider writing one.",
    "empty.state.v64": "No entries. Consider writing one.",
    "empty.state.v65": "Nothing here. The desk is grateful.",
    "empty.state.v66": "Empty, like the print room on Sundays.",
    "empty.state.v67": "Blank, but typeset.",
    "empty.state.v68": "Blank, but typeset.",
    "empty.state.v69": "Nothing yet. The ferry may be late.",
    "empty.state.v70": "Nothing yet. The ferry may be late.",
    "empty.state.v71": "Nothing here. The desk is grateful.",
    "empty.state.v72": "No entries. Consider writing one.",
    "empty.state.v73": "Nothing here. The desk is grateful.",
    "empty.state.v74": "Blank, but typeset.",
    "empty.state.v75": "Nothing here. The desk is grateful.",
    "confirm.done.v1": "Confirmed twice, for the archive.",
    "confirm.done.v2": "Confirmed and initialled.",
    "confirm.done.v3": "Confirmed. You may proceed being right.",
    "confirm.done.v4": "Confirmed. You may proceed being right.",
    "confirm.done.v5": "Confirmed. The universe has been told.",
    "confirm.done.v6": "Confirmed and initialled.",
    "confirm.done.v7": "Confirmed. You may proceed being right.",
    "confirm.done.v8": "Recorded in both ledgers.",
    "confirm.done.v9": "Confirmed and initialled.",
    "confirm.done.v10": "Confirmed twice, for the archive.",
    "confirm.done.v11": "Confirmed twice, for the archive.",
    "confirm.done.v12": "Confirmed. You may proceed being right.",
    "confirm.done.v13": "Recorded in both ledgers.",
    "confirm.done.v14": "Confirmed twice, for the archive.",
    "confirm.done.v15": "Confirmed. The universe has been told.",
    "confirm.done.v16": "Confirmed twice, for the archive.",
    "confirm.done.v17": "Recorded in both ledgers.",
    "confirm.done.v18": "Confirmed and initialled.",
    "confirm.done.v19": "Confirmed twice, for the archive.",
    "confirm.done.v20": "Confirmed twice, for the archive.",
    "confirm.done.v21": "Confirmed twice, for the archive.",
    "confirm.done.v22": "Confirmed. You may proceed being right.",
    "confirm.done.v23": "Recorded in both ledgers.",
    "confirm.done.v24": "Confirmed. You may proceed being right.",
    "confirm.done.v25": "Confirmed. The universe has been told.",
    "confirm.done.v26": "Confirmed twice, for the archive.",
    "confirm.done.v27": "Confirmed. You may proceed being right.",
    "confirm.done.v28": "Confirmed. You may proceed being right.",
    "confirm.done.v29": "Confirmed and initialled.",
    "confirm.done.v30": "Confirmed. The universe has been told.",
    "confirm.done.v31": "Confirmed twice, for the archive.",
    "confirm.done.v32": "Confirmed. You may proceed being right.",
    "confirm.done.v33": "Confirmed twice, for the archive.",
    "confirm.done.v34": "Confirmed. The universe has been told.",
    "confirm.done.v35": "Confirmed. The universe has been told.",
    "confirm.done.v36": "Confirmed twice, for the archive.",
    "confirm.done.v37": "Confirmed. You may proceed being right.",
    "confirm.done.v38": "Recorded in both ledgers.",
    "confirm.done.v39": "Confirmed. The universe has been told.",
    "confirm.done.v40": "Confirmed. The universe has been told.",
    "confirm.done.v41": "Confirmed twice, for the archive.",
    "confirm.done.v42": "Confirmed. You may proceed being right.",
    "confirm.done.v43": "Confirmed. The universe has been told.",
    "confirm.done.v44": "Confirmed and initialled.",
    "confirm.done.v45": "Confirmed. The universe has been told.",
    "confirm.done.v46": "Confirmed. You may proceed being right.",
    "confirm.done.v47": "Confirmed. You may proceed being right.",
    "confirm.done.v48": "Confirmed and initialled.",
    "confirm.done.v49": "Confirmed and initialled.",
    "confirm.done.v50": "Recorded in both ledgers.",
    "confirm.done.v51": "Confirmed. You may proceed being right.",
    "confirm.done.v52": "Confirmed. You may proceed being right.",
    "confirm.done.v53": "Confirmed. The universe has been told.",
    "confirm.done.v54": "Recorded in both ledgers.",
    "confirm.done.v55": "Confirmed. The universe has been told.",
    "confirm.done.v56": "Recorded in both ledgers.",
    "confirm.done.v57": "Confirmed. You may proceed being right.",
    "confirm.done.v58": "Recorded in both ledgers.",
    "confirm.done.v59": "Confirmed and initialled.",
    "confirm.done.v60": "Confirmed. The universe has been told.",
    "confirm.done.v61": "Confirmed. The universe has been told.",
    "confirm.done.v62": "Confirmed. You may proceed being right.",
    "confirm.done.v63": "Recorded in both ledgers.",
    "confirm.done.v64": "Confirmed. You may proceed being right.",
    "confirm.done.v65": "Confirmed and initialled.",
    "confirm.done.v66": "Confirmed. The universe has been told.",
    "confirm.done.v67": "Confirmed. You may proceed being right.",
    "confirm.done.v68": "Recorded in both ledgers.",
    "confirm.done.v69": "Confirmed and initialled.",
    "confirm.done.v70": "Confirmed twice, for the archive.",
    "confirm.done.v71": "Confirmed. You may proceed being right.",
    "confirm.done.v72": "Confirmed. The universe has been told.",
    "confirm.done.v73": "Recorded in both ledgers.",
    "confirm.done.v74": "Confirmed and initialled.",
    "confirm.done.v75": "Confirmed and initialled.",
    "reader.title.v1": "Subscriber",
    "reader.title.v2": "Adjacent reader",
    "reader.title.v3": "Correspondent",
    "reader.title.v4": "Correspondent",
    "reader.title.v5": "Reader",
    "reader.title.v6": "Patron of the print",
    "reader.title.v7": "Adjacent reader",
    "reader.title.v8": "Keeper of the ledger",
    "reader.title.v9": "Adjacent reader",
    "reader.title.v10": "Adjacent reader",
    "reader.title.v11": "Subscriber",
    "reader.title.v12": "Adjacent reader",
    "reader.title.v13": "Adjacent reader",
    "reader.title.v14": "Patron of the print",
    "reader.title.v15": "Friend of the drawer",
    "reader.title.v16": "Keeper of the ledger",
    "reader.title.v17": "Adjacent reader",
    "reader.title.v18": "Bridge member",
    "reader.title.v19": "Adjacent reader",
    "reader.title.v20": "Keeper of the ledger",
    "reader.title.v21": "Reader",
    "reader.title.v22": "Reader",
    "reader.title.v23": "Correspondent",
    "reader.title.v24": "Patron of the print",
    "reader.title.v25": "Passerby",
    "reader.title.v26": "Keeper of the ledger",
    "reader.title.v27": "Capsule witness",
    "reader.title.v28": "Bridge member",
    "reader.title.v29": "Bridge member",
    "reader.title.v30": "Reader",
    "reader.title.v31": "Subscriber",
    "reader.title.v32": "Keeper of the ledger",
    "reader.title.v33": "Passerby",
    "reader.title.v34": "Patron of the print",
    "reader.title.v35": "Friend of the drawer",
    "reader.title.v36": "Passerby",
    "reader.title.v37": "Capsule witness",
    "reader.title.v38": "Reader",
    "reader.title.v39": "Adjacent reader",
    "reader.title.v40": "Reader",
    "reader.title.v41": "Keeper of the ledger",
    "reader.title.v42": "Passerby",
    "reader.title.v43": "Correspondent",
    "reader.title.v44": "Patron of the print",
    "reader.title.v45": "Passerby",
    "reader.title.v46": "Patron of the print",
    "reader.title.v47": "Friend of the drawer",
    "reader.title.v48": "Bridge member",
    "reader.title.v49": "Adjacent reader",
    "reader.title.v50": "Reader",
    "reader.title.v51": "Subscriber",
    "reader.title.v52": "Passerby",
    "reader.title.v53": "Correspondent",
    "reader.title.v54": "Subscriber",
    "reader.title.v55": "Friend of the drawer",
    "reader.title.v56": "Keeper of the ledger",
    "reader.title.v57": "Subscriber",
    "reader.title.v58": "Bridge member",
    "reader.title.v59": "Adjacent reader",
    "reader.title.v60": "Reader",
    "reader.title.v61": "Subscriber",
    "reader.title.v62": "Friend of the drawer",
    "reader.title.v63": "Passerby",
    "reader.title.v64": "Passerby",
    "reader.title.v65": "Adjacent reader",
    "reader.title.v66": "Keeper of the ledger",
    "reader.title.v67": "Passerby",
    "reader.title.v68": "Adjacent reader",
    "reader.title.v69": "Reader",
    "reader.title.v70": "Subscriber",
    "reader.title.v71": "Subscriber",
    "reader.title.v72": "Passerby",
    "reader.title.v73": "Correspondent",
    "reader.title.v74": "Patron of the print",
    "reader.title.v75": "Patron of the print",
    "reader.title.v76": "Keeper of the ledger",
    "reader.title.v77": "Patron of the print",
    "reader.title.v78": "Bridge member",
    "reader.title.v79": "Adjacent reader",
    "reader.title.v80": "Reader",
    "reader.title.v81": "Subscriber",
    "reader.title.v82": "Passerby",
    "reader.title.v83": "Bridge member",
    "reader.title.v84": "Reader",
    "reader.title.v85": "Adjacent reader",
    "reader.title.v86": "Bridge member",
    "reader.title.v87": "Passerby",
    "reader.title.v88": "Adjacent reader",
    "reader.title.v89": "Keeper of the ledger",
    "reader.title.v90": "Reader",
    "reader.title.v91": "Passerby",
    "reader.title.v92": "Keeper of the ledger",
    "reader.title.v93": "Correspondent",
    "reader.title.v94": "Patron of the print",
    "reader.title.v95": "Friend of the drawer",
    "reader.title.v96": "Keeper of the ledger",
    "reader.title.v97": "Capsule witness",
    "reader.title.v98": "Friend of the drawer",
    "reader.title.v99": "Adjacent reader",
    "reader.title.v100": "Reader",
    "reader.title.v101": "Subscriber",
    "reader.title.v102": "Subscriber",
    "reader.title.v103": "Adjacent reader",
    "reader.title.v104": "Passerby",
    "reader.title.v105": "Friend of the drawer",
    "signup.title.v1": "Free reader registration",
    "signup.title.v2": "Readers like you",
    "signup.title.v3": "Join the readership",
    "signup.title.v4": "Become a reader",
    "signup.title.v5": "Sign up, simply",
    "signup.title.v6": "Sign up, simply",
    "signup.title.v7": "Reader record",
    "signup.title.v8": "Join us in reading",
    "signup.title.v9": "The signup",
    "signup.title.v10": "The signup",
    "signup.title.v11": "Reader record",
    "signup.title.v12": "Reader record",
    "signup.title.v13": "Free reader registration",
    "signup.title.v14": "Registration, gently",
    "signup.title.v15": "Free reader registration",
    "signup.title.v16": "Reader record",
    "signup.title.v17": "Sign up to keep reading",
    "signup.title.v18": "Join us in reading",
    "signup.title.v19": "Sign up to keep reading",
    "signup.title.v20": "Join us in reading",
    "signup.title.v21": "Registration, gently",
    "signup.title.v22": "Readers like you",
    "signup.title.v23": "Readers like you",
    "signup.title.v24": "Become a reader",
    "signup.title.v25": "Free reader registration",
    "signup.title.v26": "Sign up, simply",
    "signup.title.v27": "Reader record",
    "signup.title.v28": "Join us in reading",
    "signup.title.v29": "The signup",
    "signup.title.v30": "Sign up to keep reading",
    "signup.title.v31": "Free reader registration",
    "signup.title.v32": "Sign up to keep reading",
    "signup.title.v33": "Join the readership",
    "signup.title.v34": "Become a reader",
    "signup.title.v35": "Free reader registration",
    "signup.title.v36": "Sign up, simply",
    "signup.title.v37": "Reader record",
    "signup.title.v38": "Sign up to keep reading",
    "signup.title.v39": "The signup",
    "signup.title.v40": "Registration, gently",
    "signup.title.v41": "Registration, gently",
    "signup.title.v42": "Become a reader",
    "signup.title.v43": "Join the readership",
    "signup.title.v44": "Sign up to keep reading",
    "signup.title.v45": "Free reader registration",
    "signup.title.v46": "Free reader registration",
    "signup.title.v47": "Free reader registration",
    "signup.title.v48": "Free reader registration",
    "signup.title.v49": "The signup",
    "signup.title.v50": "Free reader registration",
    "signup.title.v51": "Become a reader",
    "signup.title.v52": "Reader record",
    "signup.title.v53": "The signup",
    "signup.title.v54": "Readers like you",
    "signup.title.v55": "Readers like you",
    "signup.title.v56": "Become a reader",
    "signup.title.v57": "Reader record",
    "signup.title.v58": "Join us in reading",
    "signup.title.v59": "The signup",
    "signup.title.v60": "Become a reader",
    "signup.title.v61": "Join the readership",
    "signup.title.v62": "Registration, gently",
    "signup.title.v63": "Join the readership",
    "signup.title.v64": "Join the readership",
    "signup.title.v65": "Free reader registration",
    "signup.title.v66": "Reader record",
    "signup.title.v67": "Readers like you",
    "signup.title.v68": "Join us in reading",
    "signup.title.v69": "The signup",
    "signup.title.v70": "Become a reader",
    "signup.title.v71": "Registration, gently",
    "signup.title.v72": "Sign up to keep reading",
    "signup.title.v73": "Join the readership",
    "signup.title.v74": "Join us in reading",
    "signup.title.v75": "Reader record",
    "signup.title.v76": "Join the readership",
    "signup.title.v77": "Reader record",
    "signup.title.v78": "Reader record",
    "signup.title.v79": "The signup",
    "signup.title.v80": "Sign up to keep reading",
    "signup.title.v81": "Registration, gently",
    "signup.title.v82": "The signup",
    "signup.title.v83": "Join the readership",
    "signup.title.v84": "Registration, gently",
    "signup.title.v85": "The signup",
    "signup.title.v86": "Sign up to keep reading",
    "signup.title.v87": "Reader record",
    "signup.title.v88": "Join us in reading",
    "signup.title.v89": "The signup",
    "signup.title.v90": "Become a reader",
    "paywall.line.v1": "Subscription pending review.",
    "paywall.line.v2": "Reviews take universes.",
    "paywall.line.v3": "The teaser is the free part.",
    "paywall.line.v4": "Continue behind the desk.",
    "paywall.line.v5": "The rest is membership.",
    "paywall.line.v6": "Reading beyond costs patience.",
    "paywall.line.v7": "Continue behind the desk.",
    "paywall.line.v8": "Approval takes time and universes.",
    "paywall.line.v9": "The wall remains a wall.",
    "paywall.line.v10": "Nothing personal. Policy.",
    "paywall.line.v11": "Reviews take universes.",
    "paywall.line.v12": "Reviews take universes.",
    "paywall.line.v13": "The teaser is the free part.",
    "paywall.line.v14": "The rest is membership.",
    "paywall.line.v15": "The teaser is the free part.",
    "paywall.line.v16": "Reading beyond costs patience.",
    "paywall.line.v17": "Reviews take universes.",
    "paywall.line.v18": "Approval takes time and universes.",
    "paywall.line.v19": "Nothing personal. Policy.",
    "paywall.line.v20": "The desk holds the line.",
    "paywall.line.v21": "Subscription pending review.",
    "paywall.line.v22": "Subscription pending review.",
    "paywall.line.v23": "Subscription pending review.",
    "paywall.line.v24": "Continue behind the desk.",
    "paywall.line.v25": "The rest is membership.",
    "paywall.line.v26": "The teaser is the free part.",
    "paywall.line.v27": "The desk holds the line.",
    "paywall.line.v28": "The desk holds the line.",
    "paywall.line.v29": "Continue behind the desk.",
    "paywall.line.v30": "The desk holds the line.",
    "paywall.line.v31": "Subscription pending review.",
    "paywall.line.v32": "Reviews take universes.",
    "paywall.line.v33": "The teaser is the free part.",
    "paywall.line.v34": "Nothing personal. Policy.",
    "paywall.line.v35": "Subscription pending review.",
    "paywall.line.v36": "Nothing personal. Policy.",
    "paywall.line.v37": "The teaser is the free part.",
    "paywall.line.v38": "Approval takes time and universes.",
    "paywall.line.v39": "The teaser is the free part.",
    "paywall.line.v40": "The wall remains a wall.",
    "paywall.line.v41": "Subscription pending review.",
    "paywall.line.v42": "The desk holds the line.",
    "paywall.line.v43": "The teaser is the free part.",
    "paywall.line.v44": "Continue behind the desk.",
    "paywall.line.v45": "The rest is membership.",
    "paywall.line.v46": "Reading beyond costs patience.",
    "paywall.line.v47": "The desk holds the line.",
    "paywall.line.v48": "Approval takes time and universes.",
    "paywall.line.v49": "The rest is membership.",
    "paywall.line.v50": "Continue behind the desk.",
    "paywall.line.v51": "Subscription pending review.",
    "paywall.line.v52": "Reading beyond costs patience.",
    "paywall.line.v53": "The teaser is the free part.",
    "paywall.line.v54": "The wall remains a wall.",
    "paywall.line.v55": "Subscription pending review.",
    "paywall.line.v56": "Reading beyond costs patience.",
    "paywall.line.v57": "The desk holds the line.",
    "paywall.line.v58": "Approval takes time and universes.",
    "paywall.line.v59": "Nothing personal. Policy.",
    "paywall.line.v60": "The wall remains a wall.",
    "paywall.line.v61": "Reading beyond costs patience.",
    "paywall.line.v62": "Reviews take universes.",
    "paywall.line.v63": "The teaser is the free part.",
    "paywall.line.v64": "Subscription pending review.",
    "paywall.line.v65": "The rest is membership.",
    "paywall.line.v66": "Reading beyond costs patience.",
    "paywall.line.v67": "The desk holds the line.",
    "paywall.line.v68": "Approval takes time and universes.",
    "paywall.line.v69": "Nothing personal. Policy.",
    "paywall.line.v70": "Subscription pending review.",
    "paywall.line.v71": "Approval takes time and universes.",
    "paywall.line.v72": "Approval takes time and universes.",
    "paywall.line.v73": "Reading beyond costs patience.",
    "paywall.line.v74": "The teaser is the free part.",
    "paywall.line.v75": "The rest is membership.",
    "paywall.line.v76": "Reading beyond costs patience.",
    "paywall.line.v77": "Reading beyond costs patience.",
    "paywall.line.v78": "Nothing personal. Policy.",
    "paywall.line.v79": "Approval takes time and universes.",
    "paywall.line.v80": "Nothing personal. Policy.",
    "paywall.line.v81": "Subscription pending review.",
    "paywall.line.v82": "The wall remains a wall.",
    "paywall.line.v83": "Nothing personal. Policy.",
    "paywall.line.v84": "Continue behind the desk.",
    "paywall.line.v85": "The desk holds the line.",
    "paywall.line.v86": "Reading beyond costs patience.",
    "paywall.line.v87": "The desk holds the line.",
    "paywall.line.v88": "Approval takes time and universes.",
    "paywall.line.v89": "Nothing personal. Policy.",
    "paywall.line.v90": "The wall remains a wall.",
    "paywall.line.v91": "Continue behind the desk.",
    "paywall.line.v92": "Subscription pending review.",
    "paywall.line.v93": "The teaser is the free part.",
    "paywall.line.v94": "Nothing personal. Policy.",
    "paywall.line.v95": "The rest is membership.",
    "paywall.line.v96": "Approval takes time and universes.",
    "paywall.line.v97": "Nothing personal. Policy.",
    "paywall.line.v98": "Approval takes time and universes.",
    "paywall.line.v99": "The rest is membership.",
    "paywall.line.v100": "Approval takes time and universes.",
    "paywall.line.v101": "Reviews take universes.",
    "paywall.line.v102": "The desk holds the line.",
    "paywall.line.v103": "The teaser is the free part.",
    "paywall.line.v104": "The desk holds the line.",
    "paywall.line.v105": "The rest is membership.",
    "premium.note.v1": "The reader is ready; the seal is not",
    "premium.note.v2": "The seal is checked first",
    "premium.note.v3": "Not for the wall; for the seal",
    "premium.note.v4": "Premium travels sealed",
    "premium.note.v5": "The dispatch stays sealed",
    "premium.note.v6": "The reader is ready; the seal is not",
    "premium.note.v7": "Editors only",
    "premium.note.v8": "The reader is ready; the seal is not",
    "premium.note.v9": "Authorization is editorial",
    "premium.note.v10": "Sealed dispatch",
    "premium.note.v11": "The seal is checked first",
    "premium.note.v12": "The reader is ready; the seal is not",
    "premium.note.v13": "The reader is ready; the seal is not",
    "premium.note.v14": "The seal is checked first",
    "premium.note.v15": "Editors only",
    "premium.note.v16": "Sealed. Truly.",
    "premium.note.v17": "The reader is ready; the seal is not",
    "premium.note.v18": "The reader is ready; the seal is not",
    "premium.note.v19": "The dispatch stays sealed",
    "premium.note.v20": "Sealed dispatch",
    "premium.note.v21": "Not for the wall; for the seal",
    "premium.note.v22": "Not for the wall; for the seal",
    "premium.note.v23": "Registration does not open it",
    "premium.note.v24": "Premium travels sealed",
    "premium.note.v25": "Registration does not open it",
    "premium.note.v26": "The dispatch stays sealed",
    "premium.note.v27": "The seal is checked first",
    "premium.note.v28": "The dispatch stays sealed",
    "premium.note.v29": "The dispatch stays sealed",
    "premium.note.v30": "Sealed dispatch",
    "premium.note.v31": "Sealed. Truly.",
    "premium.note.v32": "Not for the wall; for the seal",
    "premium.note.v33": "Registration does not open it",
    "premium.note.v34": "Authorization is editorial",
    "premium.note.v35": "The seal is checked first",
    "premium.note.v36": "Sealed. Truly.",
    "premium.note.v37": "Sealed. Truly.",
    "premium.note.v38": "Premium travels sealed",
    "premium.note.v39": "Authorization is editorial",
    "premium.note.v40": "The reader is ready; the seal is not",
    "premium.note.v41": "Editors only",
    "premium.note.v42": "The seal is checked first",
    "premium.note.v43": "Authorization is editorial",
    "premium.note.v44": "Premium travels sealed",
    "premium.note.v45": "Not for the wall; for the seal",
    "premium.note.v46": "Sealed. Truly.",
    "premium.note.v47": "The reader is ready; the seal is not",
    "premium.note.v48": "The dispatch stays sealed",
    "premium.note.v49": "Sealed dispatch",
    "premium.note.v50": "Sealed dispatch",
    "premium.note.v51": "Authorization is editorial",
    "premium.note.v52": "Sealed dispatch",
    "premium.note.v53": "Registration does not open it",
    "premium.note.v54": "Registration does not open it",
    "premium.note.v55": "The dispatch stays sealed",
    "premium.note.v56": "Sealed. Truly.",
    "premium.note.v57": "Not for the wall; for the seal",
    "premium.note.v58": "Not for the wall; for the seal",
    "premium.note.v59": "Authorization is editorial",
    "premium.note.v60": "Sealed dispatch",
    "premium.note.v61": "Editors only",
    "premium.note.v62": "The reader is ready; the seal is not",
    "premium.note.v63": "Registration does not open it",
    "premium.note.v64": "The seal is checked first",
    "premium.note.v65": "Sealed. Truly.",
    "premium.note.v66": "Premium travels sealed",
    "premium.note.v67": "Not for the wall; for the seal",
    "premium.note.v68": "Authorization is editorial",
    "premium.note.v69": "Authorization is editorial",
    "premium.note.v70": "Sealed dispatch",
    "premium.note.v71": "The dispatch stays sealed",
    "premium.note.v72": "The seal is checked first",
    "premium.note.v73": "The reader is ready; the seal is not",
    "premium.note.v74": "Premium travels sealed",
    "premium.note.v75": "Sealed dispatch",
    "premium.note.v76": "Sealed dispatch",
    "premium.note.v77": "Not for the wall; for the seal",
    "premium.note.v78": "The reader is ready; the seal is not",
    "premium.note.v79": "Authorization is editorial",
    "premium.note.v80": "The reader is ready; the seal is not",
    "premium.note.v81": "Editors only",
    "premium.note.v82": "The seal is checked first",
    "premium.note.v83": "The dispatch stays sealed",
    "premium.note.v84": "The reader is ready; the seal is not",
    "premium.note.v85": "The dispatch stays sealed",
    "premium.note.v86": "Authorization is editorial",
    "premium.note.v87": "Sealed dispatch",
    "premium.note.v88": "The reader is ready; the seal is not",
    "premium.note.v89": "The reader is ready; the seal is not",
    "premium.note.v90": "The seal is checked first",
    "mascot.line.v1": "The mascot sends regards.",
    "mascot.line.v2": "Mascot unavailable for comment.",
    "mascot.line.v3": "The mascot declines.",
    "mascot.line.v4": "The mascot declines.",
    "mascot.line.v5": "The duck is not the duck.",
    "mascot.line.v6": "The mascot declines.",
    "mascot.line.v7": "The mascot is fine.",
    "mascot.line.v8": "The duck is not the duck.",
    "mascot.line.v9": "Mascot hours: never",
    "mascot.line.v10": "The mascot declines.",
    "mascot.line.v11": "Two pigeons were consulted.",
    "mascot.line.v12": "The capybara has no comment.",
    "mascot.line.v13": "The mascot sends regards.",
    "mascot.line.v14": "The duck is not the duck.",
    "mascot.line.v15": "The duck is not the duck.",
    "mascot.line.v16": "Two pigeons were consulted.",
    "mascot.line.v17": "The duck is not the duck.",
    "mascot.line.v18": "The capybara has no comment.",
    "mascot.line.v19": "The mascot sends regards.",
    "mascot.line.v20": "The mascot is fine.",
    "mascot.line.v21": "The mascot sends regards.",
    "mascot.line.v22": "Mascot unavailable for comment.",
    "mascot.line.v23": "Mascot unavailable for comment.",
    "mascot.line.v24": "Mascot litigation pending.",
    "mascot.line.v25": "The mascot is fine.",
    "mascot.line.v26": "Two pigeons were consulted.",
    "mascot.line.v27": "The mascot is fine.",
    "mascot.line.v28": "The capybara has no comment.",
    "mascot.line.v29": "The mascot sends regards.",
    "mascot.line.v30": "The mascot is fine.",
    "mascot.line.v31": "Mascot hours: never",
    "mascot.line.v32": "Mascot unavailable for comment.",
    "mascot.line.v33": "Mascot unavailable for comment.",
    "mascot.line.v34": "The mascot is fine.",
    "mascot.line.v35": "The duck is not the duck.",
    "mascot.line.v36": "Two pigeons were consulted.",
    "mascot.line.v37": "Mascot hours: never",
    "mascot.line.v38": "The capybara has no comment.",
    "mascot.line.v39": "Mascot litigation pending.",
    "mascot.line.v40": "The mascot is fine.",
    "mascot.line.v41": "The mascot sends regards.",
    "mascot.line.v42": "Mascot unavailable for comment.",
    "mascot.line.v43": "The mascot sends regards.",
    "mascot.line.v44": "Mascot litigation pending.",
    "mascot.line.v45": "The duck is not the duck.",
    "mascot.line.v46": "Two pigeons were consulted.",
    "mascot.line.v47": "Mascot unavailable for comment.",
    "mascot.line.v48": "The heron abstained.",
    "mascot.line.v49": "Two pigeons were consulted.",
    "mascot.line.v50": "Mascot litigation pending.",
    "mascot.line.v51": "The mascot sends regards.",
    "mascot.line.v52": "Mascot litigation pending.",
    "mascot.line.v53": "The mascot declines.",
    "mascot.line.v54": "Mascot litigation pending.",
    "mascot.line.v55": "The duck is not the duck.",
    "mascot.line.v56": "Mascot hours: never",
    "mascot.line.v57": "The heron abstained.",
    "mascot.line.v58": "The capybara has no comment.",
    "mascot.line.v59": "Mascot hours: never",
    "mascot.line.v60": "The capybara has no comment.",
    "mascot.line.v61": "Two pigeons were consulted.",
    "mascot.line.v62": "The mascot declines.",
    "mascot.line.v63": "The mascot is fine.",
    "mascot.line.v64": "Mascot litigation pending.",
    "mascot.line.v65": "The duck is not the duck.",
    "mascot.line.v66": "The mascot sends regards.",
    "mascot.line.v67": "The heron abstained.",
    "mascot.line.v68": "The capybara has no comment.",
    "mascot.line.v69": "Mascot unavailable for comment.",
    "mascot.line.v70": "The mascot is fine.",
    "mascot.line.v71": "The mascot sends regards.",
    "mascot.line.v72": "The duck is not the duck.",
    "mascot.line.v73": "The mascot declines.",
    "mascot.line.v74": "The mascot is fine.",
    "mascot.line.v75": "The duck is not the duck.",
    "mascot.line.v76": "The duck is not the duck.",
    "mascot.line.v77": "Mascot unavailable for comment.",
    "mascot.line.v78": "Two pigeons were consulted.",
    "mascot.line.v79": "The mascot declines.",
    "mascot.line.v80": "The mascot sends regards.",
    "mascot.line.v81": "The duck is not the duck.",
    "mascot.line.v82": "Mascot hours: never",
    "mascot.line.v83": "The mascot is fine.",
    "mascot.line.v84": "The mascot sends regards.",
    "mascot.line.v85": "The mascot declines.",
    "mascot.line.v86": "The duck is not the duck.",
    "mascot.line.v87": "The heron abstained.",
    "mascot.line.v88": "The capybara has no comment.",
    "mascot.line.v89": "Mascot hours: never",
    "mascot.line.v90": "The mascot sends regards.",
    "bridge.line.v1": "The bridge observes silence",
    "bridge.line.v2": "Mind the corridor.",
    "bridge.line.v3": "The ferry precedes the bridge.",
    "bridge.line.v4": "The ferry precedes the bridge.",
    "bridge.line.v5": "The bridge is closed for paper.",
    "bridge.line.v6": "Crossing counted",
    "bridge.line.v7": "The bridge tilts, politely",
    "bridge.line.v8": "The bridge tilts, politely",
    "bridge.line.v9": "Mind the other side",
    "bridge.line.v10": "The ferry precedes the bridge.",
    "bridge.line.v11": "The bridge is closed for paper.",
    "bridge.line.v12": "Mind the corridor.",
    "bridge.line.v13": "The ferry precedes the bridge.",
    "bridge.line.v14": "Bridge hours: tidal",
    "bridge.line.v15": "The bridge observes silence",
    "bridge.line.v16": "The ferry precedes the bridge.",
    "bridge.line.v17": "The bridge is closed for paper.",
    "bridge.line.v18": "The bridge tilts, politely",
    "bridge.line.v19": "The bridge observes silence",
    "bridge.line.v20": "The bridge is open.",
    "bridge.line.v21": "The bridge is closed for paper.",
    "bridge.line.v22": "Mind the corridor.",
    "bridge.line.v23": "Crossing counted",
    "bridge.line.v24": "The ferry precedes the bridge.",
    "bridge.line.v25": "The bridge observes silence",
    "bridge.line.v26": "Return crossing free",
    "bridge.line.v27": "The bridge tilts, politely",
    "bridge.line.v28": "The bridge tilts, politely",
    "bridge.line.v29": "Mind the other side",
    "bridge.line.v30": "The bridge is open.",
    "bridge.line.v31": "Crossing counted",
    "bridge.line.v32": "The bridge observes silence",
    "bridge.line.v33": "Return crossing free",
    "bridge.line.v34": "Bridge hours: tidal",
    "bridge.line.v35": "The bridge observes silence",
    "bridge.line.v36": "Crossing counted",
    "bridge.line.v37": "Bridge hours: tidal",
    "bridge.line.v38": "Crossing counted",
    "bridge.line.v39": "Mind the corridor.",
    "bridge.line.v40": "The bridge is open.",
    "bridge.line.v41": "The bridge tilts, politely",
    "bridge.line.v42": "Mind the corridor.",
    "bridge.line.v43": "Mind the corridor.",
    "bridge.line.v44": "Bridge hours: tidal",
    "bridge.line.v45": "Mind the other side",
    "bridge.line.v46": "Bridge hours: tidal",
    "bridge.line.v47": "Mind the other side",
    "bridge.line.v48": "The bridge tilts, politely",
    "bridge.line.v49": "Mind the other side",
    "bridge.line.v50": "The bridge is open.",
    "bridge.line.v51": "The bridge is closed for paper.",
    "bridge.line.v52": "Mind the corridor.",
    "bridge.line.v53": "Return crossing free",
    "bridge.line.v54": "Mind the corridor.",
    "bridge.line.v55": "The bridge observes silence",
    "bridge.line.v56": "Crossing counted",
    "bridge.line.v57": "Return crossing free",
    "bridge.line.v58": "The ferry precedes the bridge.",
    "bridge.line.v59": "Mind the other side",
    "bridge.line.v60": "The bridge is open.",
    "bridge.line.v61": "The bridge is closed for paper.",
    "bridge.line.v62": "Mind the corridor.",
    "bridge.line.v63": "The bridge is open.",
    "bridge.line.v64": "The bridge is closed for paper.",
    "bridge.line.v65": "The bridge observes silence",
    "bridge.line.v66": "Crossing counted",
    "bridge.line.v67": "Return crossing free",
    "bridge.line.v68": "The bridge tilts, politely",
    "bridge.line.v69": "The ferry precedes the bridge.",
    "bridge.line.v70": "Mind the corridor.",
    "bridge.line.v71": "The bridge is closed for paper.",
    "bridge.line.v72": "Mind the corridor.",
    "bridge.line.v73": "Return crossing free",
    "bridge.line.v74": "The bridge is closed for paper.",
    "bridge.line.v75": "The bridge observes silence",
    "archive.line.v1": "The archive locks for symmetry.",
    "archive.line.v2": "Retired plates rest here.",
    "archive.line.v3": "Ask the plate ledger.",
    "archive.line.v4": "Bound volumes, roughly bound.",
    "archive.line.v5": "The archive remembers so you choose not to.",
    "archive.line.v6": "Bound volumes, roughly bound.",
    "archive.line.v7": "Retired plates rest here.",
    "archive.line.v8": "Older editions live here.",
    "archive.line.v9": "Ask the plate ledger.",
    "archive.line.v10": "The archive remembers so you choose not to.",
    "archive.line.v11": "The archive locks for symmetry.",
    "archive.line.v12": "The archive locks for symmetry.",
    "archive.line.v13": "Dust is a feature.",
    "archive.line.v14": "Older editions live here.",
    "archive.line.v15": "The archive locks for symmetry.",
    "archive.line.v16": "Older editions live here.",
    "archive.line.v17": "Ask the plate ledger.",
    "archive.line.v18": "Dust is a feature.",
    "archive.line.v19": "Retired plates rest here.",
    "archive.line.v20": "Ask the plate ledger.",
    "archive.line.v21": "Ask the plate ledger.",
    "archive.line.v22": "Older editions live here.",
    "archive.line.v23": "Retired plates rest here.",
    "archive.line.v24": "Older editions live here.",
    "archive.line.v25": "Ask the plate ledger.",
    "archive.line.v26": "The archive remembers so you choose not to.",
    "archive.line.v27": "Ask the plate ledger.",
    "archive.line.v28": "Bound volumes, roughly bound.",
    "archive.line.v29": "The archive remembers so you choose not to.",
    "archive.line.v30": "The archive locks for symmetry.",
    "archive.line.v31": "Dust is a feature.",
    "archive.line.v32": "Older news, same ink.",
    "archive.line.v33": "The archive locks for symmetry.",
    "archive.line.v34": "Bound volumes, roughly bound.",
    "archive.line.v35": "The archive remembers so you choose not to.",
    "archive.line.v36": "Older news, same ink.",
    "archive.line.v37": "Retired plates rest here.",
    "archive.line.v38": "Retired plates rest here.",
    "archive.line.v39": "Bound volumes, roughly bound.",
    "archive.line.v40": "Dust is a feature.",
    "archive.line.v41": "Dust is a feature.",
    "archive.line.v42": "Older editions live here.",
    "archive.line.v43": "The archive locks for symmetry.",
    "archive.line.v44": "Older editions live here.",
    "archive.line.v45": "The archive remembers so you choose not to.",
    "archive.line.v46": "Dust is a feature.",
    "archive.line.v47": "Retired plates rest here.",
    "archive.line.v48": "Ask the plate ledger.",
    "archive.line.v49": "The archive locks for symmetry.",
    "archive.line.v50": "Dust is a feature.",
    "archive.line.v51": "Bound volumes, roughly bound.",
    "archive.line.v52": "Dust is a feature.",
    "archive.line.v53": "Older editions live here.",
    "archive.line.v54": "Ask the plate ledger.",
    "archive.line.v55": "Retired plates rest here.",
    "archive.line.v56": "The archive locks for symmetry.",
    "archive.line.v57": "Older editions live here.",
    "archive.line.v58": "The archive locks for symmetry.",
    "archive.line.v59": "Retired plates rest here.",
    "archive.line.v60": "Dust is a feature.",
    "archive.line.v61": "The archive remembers so you choose not to.",
    "archive.line.v62": "Bound volumes, roughly bound.",
    "archive.line.v63": "Retired plates rest here.",
    "archive.line.v64": "Older editions live here.",
    "archive.line.v65": "The archive locks for symmetry.",
    "archive.line.v66": "Dust is a feature.",
    "archive.line.v67": "Retired plates rest here.",
    "archive.line.v68": "Older editions live here.",
    "archive.line.v69": "Bound volumes, roughly bound.",
    "archive.line.v70": "Bound volumes, roughly bound.",
    "archive.line.v71": "Retired plates rest here.",
    "archive.line.v72": "Retired plates rest here.",
    "archive.line.v73": "The archive locks for symmetry.",
    "archive.line.v74": "Older editions live here.",
    "archive.line.v75": "Older editions live here.",
    "section.name.0": "Front",
    "section.name.1": "Bureaus",
    "section.name.2": "Multiverse",
    "section.name.3": "Corrections",
    "section.name.4": "Weather (all)",
    "section.name.5": "Ferry desk",
    "section.name.6": "Archive",
    "section.name.7": "Print",
    "reader.greeting.formal": "The paper remembers you fondly.",
    "plate.ledger.a30": "2527db2a66cef1bc45c3abbdefed3819"
  }
}
